<template>
    <b-row class="neu-cards-ctn" cols="1" cols-xl="4">
        <PatientPanelServiceBlock v-for="block in blocks" :id="block.id" :visible="!block.invisible" :key="block.path" :title="block.title" :img="block.img" :path="block.path" :soonLabel="block.soonLabel" :action="block.action" :backgroundColor="block.backgroundColor" :textAndIconColor="block.textAndIconColor" :description="block.description">
            <template v-if="block.showOptionsBtn" #absolute-items>
				<b-icon-gear :id="`showHistoryOptions${block.id}`" @click.stop="" class="history-gear-options mb-1" scale="1.3"></b-icon-gear>
                <b-popover :target="`showHistoryOptions${block.id}`" triggers="click blur" placement="bottom">
                    <b-row>
                        <b-col cols="12" @click.stop="petSelected(block.path)" v-if="$store.state.session.user ? $store.state.session.user.havePets : false"><div><span>{{$t('clinic-history.selectPet')}}</span></div></b-col>
                        <b-col v-if="showGrantAccessBlock(block.id)" cols="12" @click.stop="showGrantAccessHistoryModal = true"><div><span>{{$t('clinic-history.grant-access')}}</span></div></b-col>
                        <b-col v-if="showProfAndCenterAuthorizedBlock(block.id)" cols="12" @click.stop="showProfAndCenterAuthorizedModal = true"><div><span>{{$t('clinic-history.access-authorizated')}}</span></div></b-col>
                    </b-row>
                </b-popover>
			</template>
        </PatientPanelServiceBlock>
        <history-prof-and-center-authorized v-model="showProfAndCenterAuthorizedModal"></history-prof-and-center-authorized>
        <change-pet-modal v-model="changePetModalVisible" :path="petsPath"></change-pet-modal>
        <history-grant-access v-model="showGrantAccessHistoryModal"></history-grant-access>
    </b-row>
</template>

<script>
import { BPopover } from 'bootstrap-vue'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'
import { HEALTH_VARS_PATH, DOCUMENTS_HISTORY_PATH, HEALTH_DATA, HEALTH_VARS, FEEDING_HABITS, MOOD_AND_HABITS, HISTORY_AND_DISEASES, QUIZ_TYPES, QUIZ_PATH } from '@/constants/clinicHistory'
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock'
import ChangePetModal from '@/components/shared/ChangePetModal'
import HistoryGrantAccess from '@/components/shared/HistoryGrantAccess'
import HistoryProfAndCenterAuthorized from '@/components/shared/HistoryProfAndCenterAuthorized'
import { GREEN_COLOUR, BLACK_COLOUR, BLUE_COLOUR } from '@/constants/colours.js'

export default {
    components: {
        PatientPanelServiceBlock,
        BPopover,
        ChangePetModal,
        HistoryGrantAccess,
        HistoryProfAndCenterAuthorized
    },
    methods: {
        petSelected (path) {
            this.petsPath = path
            this.changePetModalVisible = true
        },
        showGrantAccessBlock (id) {
            return id === HEALTH_VARS_PATH
        },
        showProfAndCenterAuthorizedBlock (id) {
            return id === HEALTH_VARS_PATH
        }
    },
    mixins: [clinicHistoryMixin],
    data () {
        return {
            showGrantAccessHistoryModal: false,
            changePetModalVisible: false,
            showProfAndCenterAuthorizedModal: false,
            petsPath: null
        }
    },
    computed: {
        blocks () {
            let _this = this
            const quizsToComplete = [QUIZ_TYPES[HEALTH_VARS], QUIZ_TYPES[HISTORY_AND_DISEASES], QUIZ_TYPES[MOOD_AND_HABITS], QUIZ_TYPES[FEEDING_HABITS]]
			let completedQuiz = this.$store.state.session.user && this.$store.state.session.user.historyCompletedQuizs ? quizsToComplete.every(id => this.$store.state.session.user.historyCompletedQuizs.includes(id)) : false
            return [
                {
					id: 'health-profile',
					title: this.$t('healthProfile'),
					action () {
                        _this.goToSection(QUIZ_PATH)
					},
					backgroundColor: completedQuiz ? GREEN_COLOUR : null,
					textAndIconColor: completedQuiz ? BLACK_COLOUR : BLUE_COLOUR,
					description: completedQuiz ? this.$t('completed') : null,
					img: '/static-appopensalud/img/icons/history-quiz.svg'
				},
                {
                    id: HEALTH_VARS_PATH,
                    action () { _this.goToSection(HEALTH_VARS_PATH) },
                    title: this.$t('clinicHistory'),
                    img: '/static-appopensalud/img/icons/clinic-history.svg',
                    showOptionsBtn: this.$store.state.session.user
                },
                {
                    id: HEALTH_DATA,
                    action () { _this.goToSection(HEALTH_DATA) },
                    title: this.$t('healthData'),
                    img: '/static-appopensalud/img/icons/information-interest.svg',
                    showOptionsBtn: this.$store.state.session.user && this.$store.state.session.user.havePets
                },
                {
                    id: DOCUMENTS_HISTORY_PATH,
                    action () { _this.goToSection(DOCUMENTS_HISTORY_PATH) },
                    title: this.$t('documentsAndInformation'),
                    img: '/static-appopensalud/img/icons/clinic-documents.svg',
                    showOptionsBtn: this.$store.state.session.user && this.$store.state.session.user.havePets
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.neu-cards-history-menu-ctn {
  justify-content: center;
  @include tablets {
    margin-left: 6rem;
  }

  // @include mobile {
  //   padding: {
  //     left: 2rem;
  //     right: 2rem;
  //   }
  // }
  > div {
      @include screen-lg-grid {
        margin-right: 2rem;
      }
    cursor: pointer;
  }
  :last-child{
    margin-right: 0;
  }
}
.popover-body .row {
    &> div {
        text-align: center;
        span{
            cursor: pointer;
            color: $blue;
            &:hover{
                text-decoration: underline;
            }
        }
    }
}
.history-gear-options{
    position: absolute;
    right: 45px;
    @include media(mobile, tablets) {
        right: 20px
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/clinicHistory/ClinicHistoryMenu.vue